/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @param {Customer} customerObj
 * @constructor
 */
export let TabInfo = function ($, config, library, customerObj) {

  /**
   * @type {string}
   */
  let template = `
<div class="slp-tab-grid">
    <div class="slp-tab-grid-row">
            <div class="slp-tab-grid-col slp-strong">
               ` + config.getPopupText().earningPoints + `
            </div>
            <div class="slp-tab-grid-col slp-strong text-center">
             ` + config.getPopupText().numberPoints + `
            </div>  
        </div>
    {{#rewards}}
        <div class="slp-tab-grid-row">
            <div class="slp-tab-grid-col">
                {{name}}
                {{#hasLinks}}        
                    <div class="slp-tab-info">
                        {{#links}}
                            {{#inInput}}
                                <button id="slp-copy" class="slp-btn-primary">` + config.getPopupText().copyLink + `</button>
                                <input type="text" value="{{url}}" {{&linkAttr}} style="position: absolute; z-index: -1; opacity: 0;">
                            {{/inInput}}
                            {{^inInput}}
                                <a class="{{&class}}" href="{{url}}" title="{{&title}}" target="_blank" {{&linkAttr}}>{{&label}}</a>
                            {{/inInput}}
                        {{/links}}
                    </div>
                {{/hasLinks}}
            </div>
            <div class="slp-tab-grid-col text-center">
                {{&value}}
            </div>  
        </div>
    {{/rewards}}
</div>        
`;

  /**
   * @type {string}
   */
  let purchaseTemplate = '1 {{&singular}} ' + config.getPopupText().forEach + ' {{&amount}}';

  /**
   * @type {{tab: string, heading: string}}
   */
  let texts = config.getTexts().popup_pages.text.info;

  /**
   * @return {{tab: string, heading: string}}
   */
  this.getTitle = () => {
    return texts;
  };

  /**
   *
   * @param urlString
   * @returns {string|*}
   */
  this.checkHttps = (urlString) => {
    if (urlString.match(/^http(s)?:\/\//)) {
      if (urlString.match(/^http:\/\//)) {
        urlString =  urlString.replace((/^http:\/\//), 'https://');
      }
      return urlString;
    }
    return 'https://' + urlString;
  };

  /**
   * @return {string}
   */
  this.getBody = () => {

    let rewardRates = config.getRewardsRates();
    let pointNames = config.getPointNames();
    let customer = config.getCustomer();

    let rewards = [];

    for (let type in rewardRates) {
      if (!rewardRates.hasOwnProperty(type) || !rewardRates[type].active) {
        continue;
      }
      let reward = {
        type: type,
        name: config.rewardNames()[type],
        amount: rewardRates[type].amount
      };

      if (customer.id) {
        if (type === 'referral') {
          // Show referral link
          reward.text = 'Your referral link:';
          reward.links = [{
            url: customerObj.getReferralLink(),
            inInput: true
          }];
        } else if (type === 'share') {
          // Show links for social subscription
          reward.links = [];
          let socials = config.getSocials();
          for (let s in socials) {
            if (!socials.hasOwnProperty(s) || !socials[s].active || !socials[s].url) {
              continue;
            }
            let url =  this.checkHttps(socials[s].url);
            reward.links.push({
              label: config.socialIcons()[s],
              title: config.socialNames()[s],
              url: url,
              class: 'spl-social-link',
              linkAttr: 'data-spl-social-link="' + s + '"'
            });
          }
        }
      } else {
        if (type === 'register') {
          // Show link to account registration
          reward.links = [{
            label: config.customization().tabInfoSignup || config.getPopupText().singUp,
            title: '',
            class: 'slp-btn-primary',
            url: '/account/register'
          }];
        }
      }
      rewards.push(reward);
    }
    return library.mustache().render(
      config.customization().tabInfoTemplate || template,
      {
        header: texts.heading,
        rewards: rewards,
        singular: pointNames.singular,
        plural: pointNames.plural,
        min_subtotal: library.formatMoney(config.getMinSubTotal()),
        max_points_part: config.getMaxPointsPart(),
        spend_rate: library.formatMoney(config.getRedeemRate()),
        value: function () {
          if (this.type === 'purchase') {
            return library.mustache().render(
              config.customization().tabInfoPurchaseTemplate || purchaseTemplate,
              {
                singular: pointNames.singular,
                amount: library.formatMoney(this.amount)
              }
            );
          }
          return this.amount + ' ' + (this.amount !== 1 ? pointNames.plural : pointNames.singular);
        },
        hasLinks: function () {
          return typeof (this.links) !== 'undefined' && this.links.length;
        }
      }
    );
  };

  /**
   * @param {HTMLElement} tabsContainer
   */
  this.afterDisplay = (tabsContainer) => {
    $(tabsContainer).find('[data-spl-social-link]').on(
      'click',
      function () {
        customerObj.takeSocialFollow(this.getAttribute('data-spl-social-link'));
        return true;
      }
    );
    $(tabsContainer).find('input[type="text"]').on(
      'click',
      function () {
        //this.select();
        this.focus();
        this.setSelectionRange(0, 999999);
      }
    );
    $(tabsContainer).find('#slp-copy').on('click', function () {
      let input = $(this).next('input')[0];
      input.focus();
      input.setSelectionRange(0, 999999);
      document.execCommand('copy');
      this.innerHTML = config.getPopupText().copiedLink;
    });
  };
};